import React, { useState, useEffect, useRef } from "react";
import {
  useScroll,
  motion,
  useMotionValueEvent,
  useAnimation,
  useSpring,
} from "framer-motion";

import { useInView } from "react-intersection-observer";
import { ScrollReveal } from "Components/Common/Helpers/ScrollReveal";

const cardsVariant = {
  visible: {
    opacity: 1,
    transition: { duration: 0.5 },
    translateY: 0,
  },
  hidden: { opacity: 0, translateY: "30%" },
};

function About() {
  const [ref, inView] = useInView();
  const [ref2, inView2] = useInView();
  const { scrollYProgress, scrollY } = useScroll();
  const [scrollOffset, setScrollOffset] = useState(-150);
  const [fadeOffset, setFadeOffset] = useState();
  const [fadeOffsetDiff, setFadeOffsetDiff] = useState(0);
  const [maxHeight, setMaxHeight] = useState();
  const control_1 = useAnimation();
  const control_2 = useAnimation();
  const [scrollLegth, setScrollLength] = useState(0);

  useEffect(() => {
    console.log("inView", inView);
    if (inView) {
      control_1.start("visible");
    }
  }, [inView, scrollYProgress, fadeOffset, fadeOffsetDiff, maxHeight]);
  useEffect(() => {
    console.log("inView", inView2);
    if (inView2) {
      control_2.start("visible");
    }
  }, [inView2]);
  useEffect(() => {
    if (window.innerWidth <= 1130 && window.innerWidth > 768) {
      setScrollLength("50px");
    } else if (window.innerWidth <= 768) {
      setScrollLength("20px");
    } else {
      setScrollLength("60px");
    }
  }, []);
  useEffect(() => {
    if (window.innerWidth < 768) {
      setScrollOffset(-300);
    } else {
      setScrollOffset(-500);
    }
  }, []);
  const onScrollPage = () => {
    const offset = window?.scrollY;
    if (offset > 8 && !maxHeight) {
      var ele1 = document.getElementById("About");
      if (ele1) {
        var offsetHeight = ele1.offsetHeight;
        setMaxHeight(offsetHeight - 290);
      }
    }
    let ele = document.getElementById("About");
    if (ele1) {
      let offsetDiv = ele.offsetTop;
      setFadeOffsetDiff(offsetDiv - 200);
      console.log("ppp", offset, offsetDiv);
    }
    console.log("ppp", offset);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScrollPage, true);
    return () => {
      window.removeEventListener("scroll", onScrollPage);
    };
  }, []);
  useEffect(() => {}, []);
  useMotionValueEvent(scrollY, "change", (latest) => {
    console.log(
      "Page scroll: ",
      latest,
      fadeOffset - fadeOffsetDiff,
      maxHeight
    );
    setFadeOffset(latest);
  });

  return (
    <div id="About" class="pt-6 pb-10 relative">
      <div class="container px-4 md:px-20 mx-auto flex flex-wrap flex-col md:flex-row items-center">
        <div className="w-full py-10 min-h-screen space-y-[120px]">
          <div className="w-full flex flex-col items-center justify-center space-y-2 lg:space-y-4">
            <ScrollReveal offset={scrollOffset}>
              <motion.div
                ref={ref2}
                variants={cardsVariant}
                initial="hidden"
                animate={control_2}
                className="mt-6 py-4 w-full max-w-[100vw] z-20 flex flex-row items-center justify-center"
              >
                <h4 class="text-xs font-light md:text-sm uppercase px-6 leading-normal text-primary-peddle-500 tracking-[1.2px] lg:tracking-[1.4px] text-center poppins pb-2 border-b-2 lg:border-b-4 w-max border-primary-caarya-medium">
                  About Us
                </h4>
              </motion.div>
            </ScrollReveal>

            <ScrollReveal offset={scrollOffset}>
              <motion.div
                ref={ref2}
                variants={cardsVariant}
                initial="visible"
                animate={control_2}
                className="w-full max-w-[100vw] z-20 flex flex-row items-center justify-center"
              >
                <h4 class="text-2xl font-light md:text-[32px] px-6 leading-9 tracking-[2.4px] lg:tracking-[3.2px] lg:leading-[48px] text-black text-center poppins w-max">
                  Get to know Us Better
                </h4>
              </motion.div>
            </ScrollReveal>

            <ScrollReveal offset={scrollOffset}>
              <motion.div
                ref={ref2}
                variants={cardsVariant}
                initial="visbile"
                animate={control_2}
                className="w-full max-w-[100vw] z-20 flex flex-row items-center justify-center"
              >
                <h4 class="text-sm font-light md:text-[18px] leading-7 lg:leading-9 text-primary-neutral-500 text-center inter max-w-4xl">
                  Caarya is an ecosystem of Indian students, startups and
                  promoters who aim to supplement knowledge, skills, values,
                  beliefs, habits and attitudes with learning experiences. We do
                  this by setting up centers of excellence in various colleges
                  across India where students learn, train, become masters and
                  earn through our various work study programs.
                  <br />
                  <br />
                  Tailor-made and uniquely adapted to suit the academic schedule
                  of each college, Caarya Excellence Centers are committed to
                  shaping a student's skillsets, helping them transform into
                  thought leaders, master strategists and innovators - the
                  building blocks of the new Indian startup ecosystem .
                </h4>
              </motion.div>
            </ScrollReveal>
          </div>
          <div className="relative max-w-6xl mx-5 xl:mx-auto px-3 pt-8 md:px-8 xl:px-0 space-y-[120px]">
            <div className="w-full flex flex-col items-center space-y-12">
              <motion.div
                ref={ref}
                variants={cardsVariant}
                initial="hidden"
                animate={control_1}
                className="w-full z-20 flex flex-row items-center justify-center"
              >
                <img
                  src="/assets/FutureVersion/Home/About/bottom.png"
                  alt=""
                  className="object-contain mx-auto"
                />
              </motion.div>
              <ScrollReveal offset={scrollOffset}>
                <motion.div
                  ref={ref}
                  variants={cardsVariant}
                  initial="hidden"
                  animate={control_1}
                  className="w-full z-20 flex flex-row items-center justify-center"
                >
                  <p className="text-[18px] text-center lg:text-2xl poppins text-black font-light tracking-[0.9px] lg:tracking-[1.2px] leading-9">
                    Feel free to check us out on our social media{" "}
                  </p>
                </motion.div>
              </ScrollReveal>
              <motion.div
                ref={ref}
                variants={cardsVariant}
                initial="visible"
                animate={control_1}
                className="w-full z-20 flex flex-row items-center justify-center"
              >
                <p className="text-black text-center poppins text-2xl font-light leading-[48px]"></p>
              </motion.div>
              <motion.div
                ref={ref}
                variants={cardsVariant}
                initial="visible"
                animate={control_1}
                className="w-full z-20 flex flex-row items-center justify-center space-x-10 lg:space-x-16"
              >
                <div className="flex flex-row items-center p-2 justify-center bg-primary-neutral-50 rounded">
                  <a
                    href="https://www.instagram.com/caarya.in/?igshid=MDM4ZDc5MmU%3D"
                    target="blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M20.0007 14.9999C18.6746 14.9999 17.4028 15.5267 16.4651 16.4644C15.5274 17.4021 15.0007 18.6738 15.0007 19.9999C15.0007 21.326 15.5274 22.5978 16.4651 23.5355C17.4028 24.4731 18.6746 24.9999 20.0007 24.9999C21.3267 24.9999 22.5985 24.4731 23.5362 23.5355C24.4739 22.5978 25.0007 21.326 25.0007 19.9999C25.0007 18.6738 24.4739 17.4021 23.5362 16.4644C22.5985 15.5267 21.3267 14.9999 20.0007 14.9999ZM20.0007 11.6666C22.2108 11.6666 24.3304 12.5446 25.8932 14.1074C27.456 15.6702 28.334 17.7898 28.334 19.9999C28.334 22.2101 27.456 24.3297 25.8932 25.8925C24.3304 27.4553 22.2108 28.3333 20.0007 28.3333C17.7905 28.3333 15.6709 27.4553 14.1081 25.8925C12.5453 24.3297 11.6673 22.2101 11.6673 19.9999C11.6673 17.7898 12.5453 15.6702 14.1081 14.1074C15.6709 12.5446 17.7905 11.6666 20.0007 11.6666ZM30.834 11.2499C30.834 11.8025 30.6145 12.3324 30.2238 12.7231C29.8331 13.1138 29.3032 13.3333 28.7507 13.3333C28.1981 13.3333 27.6682 13.1138 27.2775 12.7231C26.8868 12.3324 26.6673 11.8025 26.6673 11.2499C26.6673 10.6974 26.8868 10.1675 27.2775 9.77678C27.6682 9.38608 28.1981 9.16659 28.7507 9.16659C29.3032 9.16659 29.8331 9.38608 30.2238 9.77678C30.6145 10.1675 30.834 10.6974 30.834 11.2499ZM20.0007 6.66659C15.8773 6.66659 15.204 6.67825 13.2857 6.76325C11.979 6.82492 11.1023 6.99992 10.289 7.31659C9.56565 7.59659 9.04398 7.93159 8.48898 8.48825C7.96733 8.99225 7.56624 9.60756 7.31565 10.2883C6.99898 11.1049 6.82398 11.9799 6.76398 13.2849C6.67732 15.1249 6.66732 15.7683 6.66732 19.9999C6.66732 24.1233 6.67898 24.7966 6.76398 26.7149C6.82565 28.0199 7.00065 28.8983 7.31565 29.7099C7.59898 30.4349 7.93232 30.9566 8.48565 31.5099C9.04732 32.0699 9.56898 32.4049 10.2857 32.6816C11.109 32.9999 11.9857 33.1766 13.2857 33.2366C15.1257 33.3233 15.769 33.3333 20.0007 33.3333C24.124 33.3333 24.7973 33.3216 26.7157 33.2366C28.019 33.1749 28.8973 32.9999 29.7107 32.6849C30.4323 32.4033 30.9573 32.0683 31.5107 31.5149C32.0723 30.9533 32.4073 30.4316 32.684 29.7149C33.0007 28.8933 33.1773 28.0149 33.2373 26.7149C33.324 24.8749 33.334 24.2316 33.334 19.9999C33.334 15.8766 33.3223 15.2033 33.2373 13.2849C33.1757 11.9816 33.0007 11.1016 32.684 10.2883C32.4328 9.60826 32.0324 8.99319 31.5123 8.48825C31.0085 7.96633 30.3932 7.5652 29.7123 7.31492C28.8957 6.99825 28.019 6.82325 26.7157 6.76325C24.8757 6.67659 24.2323 6.66659 20.0007 6.66659ZM20.0007 3.33325C24.529 3.33325 25.094 3.34992 26.8707 3.43325C28.6457 3.51659 29.854 3.79492 30.9173 4.20825C32.0173 4.63159 32.944 5.20492 33.8707 6.12992C34.7181 6.96308 35.3739 7.9709 35.7923 9.08325C36.204 10.1449 36.484 11.3549 36.5673 13.1299C36.6457 14.9066 36.6673 15.4716 36.6673 19.9999C36.6673 24.5283 36.6507 25.0933 36.5673 26.8699C36.484 28.6449 36.204 29.8533 35.7923 30.9166C35.3751 32.0295 34.7192 33.0376 33.8707 33.8699C33.0373 34.7171 32.0295 35.3728 30.9173 35.7916C29.8557 36.2033 28.6457 36.4833 26.8707 36.5666C25.094 36.6449 24.529 36.6666 20.0007 36.6666C15.4723 36.6666 14.9073 36.6499 13.1307 36.5666C11.3557 36.4833 10.1473 36.2033 9.08398 35.7916C7.97119 35.374 6.9632 34.7182 6.13065 33.8699C5.283 33.0369 4.6272 32.029 4.20898 30.9166C3.79565 29.8549 3.51732 28.6449 3.43398 26.8699C3.35565 25.0933 3.33398 24.5283 3.33398 19.9999C3.33398 15.4716 3.35065 14.9066 3.43398 13.1299C3.51732 11.3533 3.79565 10.1466 4.20898 9.08325C4.62604 7.97022 5.28199 6.96212 6.13065 6.12992C6.96344 5.28197 7.97137 4.62613 9.08398 4.20825C10.1473 3.79492 11.354 3.51659 13.1307 3.43325C14.9073 3.35492 15.4723 3.33325 20.0007 3.33325Z"
                        fill="#363430"
                      />
                    </svg>
                  </a>
                </div>
                <div className="flex flex-row items-center p-2 justify-center bg-primary-neutral-50 rounded">
                  <a
                    href="https://www.linkedin.com/company/caarya/"
                    target="blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M30.5583 30.565H26.1167V23.6033C26.1167 21.9433 26.0833 19.8067 23.8 19.8067C21.485 19.8067 21.1317 21.6133 21.1317 23.4817V30.565H16.6883V16.25H20.955V18.2H21.0133C21.61 17.0767 23.06 15.8883 25.2267 15.8883C29.7267 15.8883 30.56 18.8517 30.56 22.7067V30.565H30.5583ZM11.6717 14.2917C11.3326 14.2921 10.9968 14.2256 10.6834 14.096C10.3701 13.9664 10.0854 13.7762 9.84576 13.5364C9.60608 13.2966 9.41609 13.0118 9.28668 12.6984C9.15728 12.3849 9.09101 12.0491 9.09167 11.71C9.092 11.1997 9.24363 10.701 9.5274 10.2769C9.81117 9.85281 10.2143 9.52239 10.6859 9.32742C11.1574 9.13245 11.6762 9.08169 12.1766 9.18157C12.677 9.28144 13.1366 9.52746 13.4972 9.88851C13.8578 10.2496 14.1032 10.7094 14.2024 11.21C14.3016 11.7105 14.2502 12.2292 14.0546 12.7005C13.8591 13.1718 13.5281 13.5746 13.1037 13.8578C12.6792 14.141 12.1819 14.292 11.6717 14.2917ZM13.8983 30.565H9.44333V16.25H13.9V30.565H13.8983ZM32.7833 5H7.215C5.98833 5 5 5.96667 5 7.16167V32.8383C5 34.0333 5.99 35 7.21333 35H32.7767C34 35 35 34.0333 35 32.8383V7.16167C35 5.96667 34 5 32.7767 5H32.7833Z"
                        fill="#363430"
                      />
                    </svg>
                  </a>
                </div>
                <div className="flex flex-row items-center p-2 justify-center bg-primary-neutral-50 rounded">
                  <a href="https://twitter.com/caaryaIN" target="blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M36.9365 9.42679C35.6641 9.98961 34.3148 10.3592 32.9332 10.5235C34.3894 9.65251 35.4794 8.28181 35.9998 6.66679C34.6332 7.48012 33.1348 8.05012 31.5732 8.35845C30.5242 7.23609 29.1338 6.49173 27.6181 6.2411C26.1024 5.99047 24.5464 6.24761 23.192 6.97254C21.8375 7.69748 20.7605 8.84959 20.1284 10.2498C19.4962 11.65 19.3444 13.2198 19.6965 14.7151C16.925 14.5762 14.2137 13.856 11.7387 12.6012C9.26358 11.3465 7.08006 9.5852 5.32984 7.43179C4.71033 8.49587 4.38477 9.7055 4.38651 10.9368C4.38651 13.3535 5.61651 15.4885 7.48651 16.7385C6.37986 16.7036 5.29756 16.4048 4.32984 15.8668V15.9535C4.33018 17.563 4.88713 19.1228 5.90626 20.3686C6.92539 21.6143 8.34398 22.4692 9.92151 22.7885C8.8942 23.0669 7.81702 23.1079 6.77151 22.9085C7.21629 24.2938 8.08319 25.5055 9.25083 26.3736C10.4185 27.2418 11.8284 27.7231 13.2832 27.7501C11.8373 28.8857 10.1818 29.7251 8.41131 30.2204C6.64082 30.7157 4.79006 30.8572 2.96484 30.6368C6.15101 32.6858 9.86001 33.7737 13.6482 33.7701C26.4698 33.7701 33.4815 23.1485 33.4815 13.9368C33.4815 13.6368 33.4732 13.3335 33.4598 13.0368C34.8246 12.0504 36.0025 10.8285 36.9382 9.42846L36.9365 9.42679Z"
                        fill="#363430"
                      />
                    </svg>
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;

function Card({ item }) {
  const [ref, inView] = useInView();
  const { scrollYProgress } = useScroll();
  const control_1 = useAnimation();
  const control_2 = useAnimation();
  useEffect(() => {
    console.log("inView", inView);
    if (inView) {
      control_1.start("visible");
      setTimeout(() => {
        control_2.start("visible");
      }, 200);
    }
    // else {
    //     control_2.start("hidden");

    //     control_1.start("hidden");
    // }
  }, [inView, scrollYProgress]);

  return (
    <div className="max-w-5xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between w-full relative">
      <motion.div
        ref={ref}
        variants={cardsVariant}
        initial="hidden"
        animate={control_1}
        className="white-card lg:w-2/3 flex flex-col space-y-6 p-10"
      >
        <div className="flex flex-row items-center justify-between">
          {React.cloneElement(item?.svg, {})}
          <p className="text-primary-neutral-400 inter text-sm font-light">
            {item?.number}
          </p>
        </div>
        <div className="flex flex-col items-start space-y-3">
          <h1 class="text-lg font-light leading-9 text-black capitalize poppins">
            {item?.name}
          </h1>
          <p class="text-base inter leading-6 font-light text-primary-neutral-500">
            {item?.description}
          </p>
        </div>
      </motion.div>

      <motion.div
        variants={cardsVariant}
        initial="hidden"
        animate={control_2}
        className=""
      >
        <img src={item?.image} alt="" className="object-contain mx-auto" />
      </motion.div>
    </div>
  );
}

function CardReverse({ item }) {
  const [ref, inView] = useInView();
  const { scrollYProgress } = useScroll();
  const control_1 = useAnimation();
  const control_2 = useAnimation();
  useEffect(() => {
    console.log("inView", inView);
    if (inView) {
      control_1.start("visible");
      setTimeout(() => {
        control_2.start("visible");
      }, 200);
    }
    // else {
    //     control_2.start("hidden");

    //     control_1.start("hidden");
    // }
  }, [inView, scrollYProgress]);

  return (
    <li className="max-w-5xl mx-auto flex flex-col-reverse lg:flex-row-reverse items-start justify-between w-full py-16 relative">
      {/* <Fade direction="left" delay="250"> */}
      <motion.div
        ref={ref}
        variants={cardsVariant}
        initial="hidden"
        animate={control_1}
        className="white-card lg:w-2/3 flex flex-col space-y-6 p-10"
      >
        <div className="flex flex-row items-center justify-between">
          {React.cloneElement(item?.svg, {})}
          <p className="text-primary-neutral-400 inter text-sm font-light">
            {item?.number}
          </p>
        </div>
        <div className="flex flex-col items-start space-y-3">
          <h1 class="text-lg font-light leading-9 text-black capitalize poppins">
            {item?.name}
          </h1>
          <p class="text-base inter leading-6 font-light text-primary-neutral-500">
            {item?.description}
          </p>
        </div>
      </motion.div>
      <motion.div
        variants={cardsVariant}
        initial="hidden"
        animate={control_2}
        className=""
      >
        <img src={item?.image} alt="" className="object-contain mx-auto" />
      </motion.div>
    </li>
  );
}
